<template>
  <!--政治面貌-->
  <el-select v-model="politicalCode" clearable>
    <el-option
      v-for="item in politicalList"
      :key="item.dictCode"
      :label="item.dictName"
      :value="item.dictCode">
    </el-option>
  </el-select>
  <!------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-political",
    data() {
      return {
        politicalList: [],
        politicalCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'POLITICS_STATUS',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.politicalList = res.data
        }
      })
    },
    watch: {
      politicalCode: function (currentVal) {
        this.$emit('politicalInfo', {politicalCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
